import RibbonButton from './RibbonButton';
import strings from 'owa-strings/owa-mail-strings';
import { Direction } from 'roosterjs-editor-types';
import { setDirection } from 'roosterjs-editor-api';

const rtl: RibbonButton = {
    key: 'rtl',
    title: () => strings.dirRtl,
    imageSrc: require('../svg/rtl.svg'),
    onExecute: plugin => setDirection(plugin.getEditor(), Direction.RightToLeft),
};

export default rtl;
